import React, { useState, useEffect } from 'react';
import { getActivationURL } from '../../Services/getActivationURL';
import MaxError from './MaxError';
import { translations } from '../Text/translations';
import hbomaxAppLogo from '../../assets/max/hbomax-applogo.png';
import hbomaxDevices from '../../assets/max/hbomax-devices.png';

const MaxNotActivated = ({ currentLang, nickname, mobilenowid, emailnowid, fsa, fsaType }) => {
  const [responseError, setResponseError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        setLoading(false);
      }
    };

    window.addEventListener('pageshow', handlePageShow);
    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);

  const handleActivateButtonClick = () => {
    if (!loading) {
      setLoading(true);
      Promise.all([
        getActivationURL('HBO')
      ]).then(([activationResponse]) => {
        if (activationResponse.url) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'partner': 'hbomax',
            'fsa_type': (fsaType || '').toLowerCase(),
            'click_location': 'partner_landing_page',
            'event': 'partner_activation_click'
          });
          window.location.href = activationResponse.url;
        } else {
          setResponseError(true);
          setLoading(false);
        }
      }).catch((error) => {
        setResponseError(true);
        setLoading(false);
      });
    }
  };

  const handleLearnMoreHereClick = () => {
    currentLang === 'en' ? window.open("https://www.nowe.com/serviceenhancementhbomax?locale=en") : window.open("https://www.nowe.com/serviceenhancementhbomax?locale=zh");
  };

  const handleSupportedDevicesClick = () => {
    const url = currentLang === 'en'
      ? 'https://help.hbomax.com/hk-en/Answer/Detail/000002506'
      : 'https://help.hbomax.com/hk/Answer/Detail/000002506';
    window.open(url, '_blank');
  };

  return (
    <>
      {responseError && (
        <MaxError
          currentLang={currentLang}
          nickname={nickname}
          mobilenowid={mobilenowid}
          emailnowid={emailnowid}
        />
      )}
      {!responseError && (
        <>
          <div className="name">
            <h2 className="name">{translations[currentLang].maxSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].maxSubjectGreeting2}</h2>
          </div>
          <div className="message">
            <p>
              {translations[currentLang].maxNotActivated}
              <br />
              <br />
              {translations[currentLang].maxRedirectToMaxRemark}
            </p>
          </div>

          <div className="cta-buttons">
            <button className="btn primary" onClick={handleActivateButtonClick}>
              {translations[currentLang].activiateMaxAccount}
            </button>
          </div>

          <p className="onceCompleted">{translations[currentLang].maxOnceCompleted}</p>

          <div className="dlhbomax-wrapper">
            <div className="app">
              <img src={hbomaxAppLogo} alt="" />
              <h4>{translations[currentLang].maxDownloadAndWatch}</h4>
            </div>
            <p>{translations[currentLang].maxAvailableDevices}</p>
            <img src={hbomaxDevices} alt="" className="img-devices" />
            <a onClick={handleSupportedDevicesClick} className="link new-window">{translations[currentLang].maxDetailOnSupportedDevices}</a>
            <small>{translations[currentLang].maxSmallNote}</small>
          </div>

          <div class="max-contact-wrapper">
            <div class="notes">
              <p>{translations[currentLang].maxNowEUser}<br /><a onClick={handleLearnMoreHereClick}>{translations[currentLang].maxLearnMoreHere}</a>{translations[currentLang].maxAboutYourMaxAccountActivation}</p>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MaxNotActivated;